// search page should not show up when aiHub route is enabled
// as it doesn't have search react context and preload
export var searchRouteGuard = function (props) {
    var canActivate = !props.isAIHubEnabled;
    return { canActivate: canActivate };
};
//# sourceMappingURL=searchPageRouteGuard.js.map